/**
 * @desc 扫描库位或箱号获取明细
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: Array<defs.wms.StockDetailRequestParamsDto>, options?: any) {
  return updateResponse(
    http(URL + `/stockPool/screenPositionList`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
